import * as i0 from '@angular/core';
import { Component, Inject, Input, NgModule } from '@angular/core';
import * as i3 from '@upr-web-primer/event-notification';
import * as i2 from '@upr-web-primer/page-labels';
import { PageLabelsModule } from '@upr-web-primer/page-labels';
import * as i1 from '@upr-web-primer/storage';
import { get, isEmpty } from 'lodash-es';
import * as i4 from '@upr-web-primer/ms-guests';
import * as i5 from '@upr-web-primer/wcs-shop';
import * as i6 from '@upr-web-primer/tcm-anchor';
import { TcmAnchorModule } from '@upr-web-primer/tcm-anchor';
import { CommonModule } from '@angular/common';

class WidgetCartComponent {
    constructor(denaliUrl, localStorage, pageLabelsService, eventNotificationService, msGuestsService, cartService) {
        this.denaliUrl = denaliUrl;
        this.localStorage = localStorage;
        this.pageLabelsService = pageLabelsService;
        this.eventNotificationService = eventNotificationService;
        this.msGuestsService = msGuestsService;
        this.cartService = cartService;
        this.count = 0;
        this.pageLabelsService.get().then((pageLabels) => {
            this.pageLabels = pageLabels;
            this.ariaLabel = this.getAriaLabel();
        });
        this.cartCountSub = this.eventNotificationService.event$.subscribe((data) => {
            if (!!data && data.action === 'cartCountUpdated') {
                this.ngOnInit();
            }
        });
    }
    ngOnInit() {
        if (this.msGuestsService.helper.isLoggedIn()) {
            this.msGuestsService.account.authN().then(() => {
                this.cartService.miniCart(true, false).then(() => {
                    this.count = this.getCount();
                    this.embeddedLink = this.getEmbedded();
                    this.ariaLabel = this.getAriaLabel();
                });
            });
        }
        else {
            this.count = this.getCount();
            this.embeddedLink = this.getEmbedded();
            this.ariaLabel = this.getAriaLabel();
        }
    }
    getCount() {
        return Number(this.localStorage.getItem('CART_ITEM_COUNT') || 0);
    }
    getEmbedded() {
        let url = this.count > 0
            ? get(this.data, 'Component.Fields.CartLink.EmbeddedValues[0]')
            : get(this.data, 'Component.Fields.CartLinkEmpty.EmbeddedValues[0]');
        if (isEmpty(url)) {
            url = get(this.data, 'Component.Fields.Link.EmbeddedValues[0].External.Values[0]', '');
            this.url = url.replace('%%DenaliURL%%', this.denaliUrl);
            return;
        }
        return url;
    }
    getAriaLabel() {
        return (this.count > 0
            ? get(this.pageLabels, 'shoppingCartIconAltText', '')
            : get(this.pageLabels, 'shoppingCartIconAltTextEmpty', '')).replace('#COUNT#', this.count);
    }
    ngOnDestroy() {
        if (this.cartCountSub) {
            this.cartCountSub.unsubscribe();
        }
    }
}
WidgetCartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WidgetCartComponent, deps: [{ token: 'DenaliUrl' }, { token: i1.LocalStorageService }, { token: i2.PageLabelsResolver }, { token: i3.EventNotificationService }, { token: i4.MsGuestsService }, { token: i5.CartService }], target: i0.ɵɵFactoryTarget.Component });
WidgetCartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: WidgetCartComponent, selector: "upr-widget-cart", inputs: { data: "data" }, ngImport: i0, template: "<tcm-anchor\n\t[embeddedValue]=\"embeddedLink\"\n\t[transclude]=\"true\"\n\t[ariaLabel]=\"ariaLabel\"\n\t[overwriteUrl]=\"url\"\n\t[anchorClass]=\"'cart-icon-link'\"\n>\n\t<div class=\"cart-item-count\" aria-hidden=\"true\" data-aui=\"cart-count\">\n\t\t{{ count }}\n\t</div>\n\t<i class=\"icon-cart shopping-cart\" aria-hidden=\"true\"></i>\n</tcm-anchor>\n", styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.shopping-cart{color:#fff;font-size:2.375rem}.cart-item-count{position:absolute;top:0;left:13px;width:18px;height:18px;border-radius:50%;font-size:10px;line-height:17px;text-align:center;background:#162b75;color:#fff}\n"], components: [{ type: i6.TcmAnchorComponent, selector: "tcm-anchor", inputs: ["embeddedValue", "chevronClass", "useRouterLinkActive", "routerLinkExact", "overwriteLinkText", "overwriteTarget", "overwriteQueryParams", "overwriteHash", "overwriteRole", "anchorClass", "anchorStyle", "analyticsTitle", "transclude", "ariaLabel", "lang", "tabindex", "overwriteUrl", "overwritePath"], outputs: ["fireEvent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WidgetCartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-widget-cart', template: "<tcm-anchor\n\t[embeddedValue]=\"embeddedLink\"\n\t[transclude]=\"true\"\n\t[ariaLabel]=\"ariaLabel\"\n\t[overwriteUrl]=\"url\"\n\t[anchorClass]=\"'cart-icon-link'\"\n>\n\t<div class=\"cart-item-count\" aria-hidden=\"true\" data-aui=\"cart-count\">\n\t\t{{ count }}\n\t</div>\n\t<i class=\"icon-cart shopping-cart\" aria-hidden=\"true\"></i>\n</tcm-anchor>\n", styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.shopping-cart{color:#fff;font-size:2.375rem}.cart-item-count{position:absolute;top:0;left:13px;width:18px;height:18px;border-radius:50%;font-size:10px;line-height:17px;text-align:center;background:#162b75;color:#fff}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['DenaliUrl']
                }] }, { type: i1.LocalStorageService }, { type: i2.PageLabelsResolver }, { type: i3.EventNotificationService }, { type: i4.MsGuestsService }, { type: i5.CartService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class WidgetCartModule {
}
WidgetCartModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WidgetCartModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
WidgetCartModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WidgetCartModule, declarations: [WidgetCartComponent], imports: [CommonModule, PageLabelsModule, TcmAnchorModule], exports: [WidgetCartComponent,
        CommonModule,
        PageLabelsModule,
        TcmAnchorModule] });
WidgetCartModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WidgetCartModule, providers: [], imports: [[CommonModule, PageLabelsModule, TcmAnchorModule], CommonModule,
        PageLabelsModule,
        TcmAnchorModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WidgetCartModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [WidgetCartComponent],
                    imports: [CommonModule, PageLabelsModule, TcmAnchorModule],
                    providers: [],
                    exports: [
                        WidgetCartComponent,
                        CommonModule,
                        PageLabelsModule,
                        TcmAnchorModule
                    ]
                }]
        }] });

export { WidgetCartComponent, WidgetCartModule };
